import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { AddPaymentMethodFormViewProps } from "models/propTypes/receiptPropTypes";
import { FormHandles, NumberFormatFieldExtraProps } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { ReceiptFormTypes } from "models/formTypes";
//#endregion
//#region components
import { StaticInfoMessage, GenericForm } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const AddPaymentMethodForm: ForwardRefRenderFunction<FormHandles, AddPaymentMethodFormViewProps> = (props, ref) => {
  return (
    <>
      <StaticInfoMessage gutterBottom>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Receipt.PaymentMethodInfoMessage)}
      </StaticInfoMessage>
      <GenericForm<ReceiptFormTypes.AddPaymentMethod>
        formRef={ref}
        {...props}
        fields={{
          paymentMethodType: {
            label: TranslationKeys.Receipt.PaymentMethodType,
            type: FormEnums.FormFieldType.TEXT,
            descriptionText: TranslationKeys.Receipt.PaymentMethodHelpText,
            readonly: true,
          },
          name: {
            label: TranslationKeys.Common.Name,
            type: FormEnums.FormFieldType.TEXT,
            descriptionText: TranslationKeys.Receipt.PaymentMethodNameHelpText,
            readonly: !(props.defaultValues as ReceiptFormTypes.AddPaymentMethod).editMode,
          },
          currencyMarkup: {
            label: TranslationKeys.Receipt.CurrencyMarkup,
            type: FormEnums.FormFieldType.NUMBER,
            descriptionText: TranslationKeys.Receipt.CurrencyMarkUpHelpText,
            classes: {
              input: cssExports.receiptCurrencyMarkup,
            },
            extraProps: {
              decimalPoints: 2,
              suffix: "%",
            } as NumberFormatFieldExtraProps,
            readonly: !(props.defaultValues as ReceiptFormTypes.AddPaymentMethod).editMode,
          },
          isActive: {
            label: " ",
            controlLabel: TranslationKeys.Common.IsActive,
            type: FormEnums.FormFieldType.TOGGLE,
            classes: { formControl: cssExports.inlineLabel },
            hidden: (values: ReceiptFormTypes.AddPaymentMethod) => !values.id,
            readonly: !(props.defaultValues as ReceiptFormTypes.AddPaymentMethod).editMode,
          },
        }}
      />
    </>
  );
};

export default forwardRef(AddPaymentMethodForm);
